<template>
    <div class="wl-container">
        <div class="wl-content-container">

            <!-- 搜索框 -->
            <div class="wl-search-bar">
                <div class="wl-left">
                    <el-input :placeholder="$t('TABLE_HEADER_roleName')+','+$t('FORM_LABEL_description')"
                                clearable
                                v-model="queryParam"
                                @keyup.enter.native="getRoleList"
                                @clear="getRoleList"
                                maxlength="100"
                                class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getRoleList" style="cursor: pointer" />
                    </el-input>
                </div>
                <div class="wl-right">
                    <el-button @click="openRole" class="wl-green" icon="el-icon-plus">{{$t('PAGE_CLIENTROLES_ADD')}}</el-button>
                    <el-button @click="onPatchDeleteClick" :disabled="patch.show" class="wl-green svg-btn"><img src="@/assets/img/icon-batchdeletion.svg" width="100%" class="btn-icon" />{{$t('patch_delete')}}</el-button>
                </div>
            </div>

            <!-- 表格 -->

            <div :class="['table-container-wrapper', patch.show? 'show-table-bottom-operate': '']">
                <el-table height="100%"
                          v-loading="loading"
                          :data="data"
                          border
                          stripe
                          @selection-change="onTableSelectChange"
                          ref="mainTable"
                >
                    <el-table-column
                            v-if="patch.show"
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column type="index" align="center"
                                     width="70"></el-table-column>

                    <el-table-column prop="roleName"
                                     :label="$t('TABLE_HEADER_roleName')"
                                     show-overflow-tooltip
                                     min-width="150"></el-table-column>

                    <el-table-column prop="roleDesc"
                                     align="center"
                                     :label="$t('FORM_LABEL_description')"></el-table-column>

                    <el-table-column prop="updateDateString"
                                     align="center"
                                     :label="$t('TABLE_HEADER_modifyDate')">
                        <template slot-scope="scope">
                            {{scope.row.updateDateString | formatDate}}
                        </template>
                    </el-table-column>


                    <el-table-column prop="action"
                                     width="170"
                                     align="center"
                                     :label="$t('TABLE_HEADER_Action')">
                        <template slot-scope="scope">
                            <i class="el-icon-edit-outline wl-icon-edit"
                               @click="editRole(scope.row)"></i>
                            <i style="margin-left: 10px" class="el-icon-delete wl-icon-delete"
                               @click="deleteRole(scope.row)"></i>
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <!-- 多选操作 -->
            <div v-if="patch.show" class="patch-bottom-btn">
                <el-button class="cancel-btn" @click="onPatchCancelClick">{{$t('btn_cancel')}}
                </el-button>
                <el-button @click="commitPatchDelete"
                            v-if="patch.show && patch.mode == 'delete'"
                            :disabled="patch.selectedRows.length <= 0"
                            class="wl-green">
                        {{$t('patch_delete')}}
                </el-button>
            </div>
            <!-- 分页 -->
            <el-pagination class="wl-pagination"
                           :current-page="pagination.pageNum"
                           :page-size="pagination.pageSize"
                           @current-change="onCurrentPageChange"
                           @size-change="onSizeChange"
                           :page-sizes="[10, 50, 100]"
                           layout="prev, pager, next,sizes, total"
                           :total="pagination.total"></el-pagination>

            <KpUserRolesAdd v-if="addVisible"
                            :saveLoading="btnLoading"
                            :initData='initData'
                            :onCancel="toggleAddVisible"
                            :onAdd="saveClientRoles"/>
        </div>
    </div>
</template>
<script>
    import API from '@/api';
    import {deleteConfirm, dateFormat} from '@/utils';
    import KpUserRolesAdd from './kpUserRole-add'
    import {mapGetters} from 'vuex'

    export default {
        data() {
            return {
                siteId: '',
                data: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                },
                queryParam: '',
                loading: false,
                searchContent: '',
                btnLoading: false,
                initData: '',
                addVisible: false,
                patch: {
                    show: false,
                    selectedRows: [],
                    mode: '' // delete
                }
            };
        },
        filters: {
            formatDate: (value) => {
                return dateFormat(new Date(value),'yyyy-MM-dd')
            }
        },
        computed: {
            ...mapGetters('common', {
                getSite: 'getSite',
            })
        },
        mounted() {
            this.siteId = this.getSite.siteId
            this.getRoleList()
        },
        methods: {
            onPatchCancelClick() {
                this.patch = {
                    show: false,
                    selectedRows: [],
                    mode: ''
                }
            },
            commitPatchDelete() {
                this.$confirm(this.$t('kpRoles_delete_sure'), {
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning',
                    cancelButtonClass: 'wl-grey',
                    confirmButtonClass: 'wl-green'
                }).then(() => {
                    API.clientRoles.deleteClientRoleList({
                        param: this.patch.selectedRows.map(v => v.roleId),
                        siteId: this.siteId
                    }).then(res => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'));
                            this.getRoleList();
                        } else {
                            this.$message.error(this.$t(res.code));
                        }
                    });
                });
            },
            onTableSelectChange(e) {
                this.patch.selectedRows = e
            },
            onPatchDeleteClick() {
                this.patch = {
                    show: true,
                    selectedRows: [],
                    mode: 'delete'
                }
                this.$refs.mainTable.clearSelection()
            },
            getRoleList() {
                this.loading = true
                const params = {
                    queryParam: this.queryParam,
                    siteId: this.siteId,
                    pageNum: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize
                }
                API.kpUserRole.queryKPMGRoleList(params).then(res => {
                    if (res.code == '1') {
                        this.data = res.data.records
                        this.pagination.total=res.data.total
                    }else {
                        this.$message.error(this.$t(res.code));
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {
                    this.loading = false
                })
            },
            deleteRole(row) {
                deleteConfirm(this.$t('kpRoles_delete_sure')).then(() => {
                    API.clientRoles.deleteClientRoleList({
                        param: [row.roleId],
                        siteId: this.siteId
                    }).then(res => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'));
                            this.getRoleList()
                        }else {
                            this.$message.error(this.$t(res.code));
                        }
                    })
                })
            },
            onSizeChange(size) {
                this.pagination.pageSize = size
                this.pagination.pageNum = 1
                this.getRoleList()
            },
            onCurrentPageChange(current) {
                this.pagination.pageNum = current;
                this.getRoleList();
            },
            getClientPermission(row) {
                row = row || {roleId: ''};
                const params = {
                    siteId: this.siteId,
                    roleId: row.roleId,
                }
                API.kpUserRole.queryKPMGPermission(params).then(res => {
                    if (res.code == '1') {
                        this.initData = Object.assign({}, {row: row}, res.data)
                        this.addVisible = !this.addVisible
                    }else {
                        this.$message.error(this.$t(res.code));
                    }
                })
            },
            openRole() {
                this.getClientPermission('')
            },
            toggleAddVisible() {
                this.addVisible = !this.addVisible
                this.initData = ''
            },
            editRole(row) {
                this.getClientPermission(row)
            },
            saveClientRoles(data) {
                if (data.roleId) {
                    const params = {
                        roleId: data.roleId,
                        siteId: this.siteId,
                        roleName: data.base.roleName,
                        roleDesc: data.base.description,
                        entityIdList: data.entityIdList,
                    }
                    API.kpUserRole.updateKPMGRole(params).then(res => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'));
                            this.addVisible = !this.addVisible
                            this.getRoleList()
                        }else {
                            this.$message.error(this.$t(res.code));
                        }
                    })
                } else {
                    const params = {
                        siteId: this.siteId,
                        roleName: data.base.roleName,
                        roleDesc: data.base.description,
                        entityIdList: data.entityIdList
                    }
                    API.kpUserRole.saveKPMGRole(params).then(res => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'));
                            this.addVisible = !this.addVisible
                            this.getRoleList()
                        }else {
                            this.$message.error(this.$t(res.code));
                        }
                    })
                }
            }
        },
        components: {KpUserRolesAdd}
    };
</script>

<style scoped>
    .wl-container {
        height: 100%;
        background: #eff1f5;
        padding: 22px;
    }

    .wl-content-container {
        background: #fff;
        height: 100%;
        padding: 22px 22px 16px 22px;
        border-radius: 8px;
    }

    .wl-search-bar {
        height: 45PX;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .wl-left,
    .wl-right {
        display: flex;
        justify-content: flex-start;
        justify-items: center;
    }


    .table-container-wrapper.show-table-bottom-operate{
        height: calc(100% - 98px - 45PX);
    }
    .patch-bottom-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 50px;
  }
</style>
